'use strict';

var toastr = require('toastr');
var GridAcceptHostShareButtonController = function GridAcceptHostShareButtonController($scope, hepService) {
  var gridPanel = $scope.gridPanelScope.$parent;
  $scope.isButtonEnable = true;
  $scope.acceptHostShare = function () {
    hepService.acceptNPS(gridPanel.getSelectedRows()).then(function () {
      toastr.success('Successfully Accepted.');
      gridPanel.refreshGridButtonHandler();
    }, function () {
      toastr.error('Error in Accepting');
    });
  };
  $scope.setAcceptButtonState = function (evt, isRowSelected) {
    $scope.isAcceptButtonEnable = isRowSelected;
  };
};
GridAcceptHostShareButtonController.$inject = ['$scope', 'HepService'];
module.exports = GridAcceptHostShareButtonController;